import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { applyFilters } from "../../store/rankings.actions"
import { getActiveFilters, getWHWFilterData } from "../../store/rankings.selectors"
import { AwardsCountryFilterBox } from "../../styles"
import SelectInput from "../filters/selectInput"

const AwardsCountryFilter = () => {
  const dispatch = useDispatch()
  const appliedFilters = useSelector(getActiveFilters)
  const filters = useSelector(getWHWFilterData)?.country

  const handleSubmit = e => {
    dispatch(applyFilters({ country: e }))
  }

  return (
    <AwardsCountryFilterBox>
      <SelectInput
        options={{
          id: "filter-country",
          label: "Country",
          items: filters || []
        }}
        isLoading={filters?.isLoading}
        filterValue={appliedFilters.country}
        onFilter={handleSubmit}
        height={36}
      />
    </AwardsCountryFilterBox>
  )
}

export default AwardsCountryFilter
